// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"5afed5d2","283":"ef7c11bf","293":"c82cfb8e","676":"708458a5","714":"493eb9a0","750":"6973931c","876":"d175e0f6","915":"62b4e1bc","922":"33bc47ca","990":"3f28d08e","999":"63ee6028"}[chunkId] + ".chunk.js";
};